import APIClient from '../../../api/APIClient';
import type { GetLevelsResponse, SearchLevelsRequest } from '@gdladder/shared/features';

export async function getLevels(q: SearchLevelsRequest) {
    const res = await APIClient.get<GetLevelsResponse>('/levels', {
        params: {
            limit: 16,
            ...q,
        },
    });
    return res.data;
}
